// Parameter types are structural so this module needs no import from `domains/reporter`, and
// so `common/` consumers do not gain an edge into a domain.
type DeviceRecord = Readonly<{
  deviceId: string;
  groupId: string;
  kind: string;
  label: string;
}>;

type DeviceIdentity = Readonly<{ deviceId: string }>;

/**
 * Full-record fingerprint: changes when any device is added, removed, relabelled, or regrouped.
 * Sorted, so a reordered-but-identical list reads as unchanged — `enumerateDevices()` ordering
 * is not guaranteed stable, and a spurious "changed" costs a mic teardown. `label` is included
 * because the dictation dropdown must relabel when the OS default moves.
 */
export const deviceListFingerprint = (devices: readonly DeviceRecord[]): string =>
  devices
    .map(({ deviceId, groupId, kind, label }) => JSON.stringify([deviceId, groupId, kind, label]))
    .sort()
    .join(',');

/**
 * Identity-only key for stream-acquisition invalidation. `label` is deliberately EXCLUDED: the
 * `default` entry's label tracks the OS default, and a pure OS-default change with no unplug
 * must NOT re-acquire. Including `label` here would regress that.
 */
export const deviceListKey = (devices: readonly DeviceIdentity[]): string =>
  devices
    .map(({ deviceId }) => JSON.stringify(deviceId))
    .sort()
    .join(',');
